module.exports = __webpack_public_path__ + "static/media/test3_2.13bf2d01.png";